<template>
    <el-dialog title="审核" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialog" width="900px" @close="closeDialog" center>
      <el-form :inline="true" ref="addFrom" :model="addFrom" class="demo-form-inline jiaoyan" label-width="110px" :rules="rules" size="mini">
       <el-form-item label="企业名称:" prop="">
           <div>{{addFrom.companyName}}</div>
        </el-form-item>
        <div class="inpBox">
          <el-form-item label="企业类型:" prop="enterpriseType">
           <el-select placeholder="请选择" value-key="id" v-model="addFrom.enterpriseType" filterable>
              <el-option  label="一般人"  :value=0></el-option>
              <el-option  label="小规模"  :value=1></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="主管税务机关:" prop="taxCompetent"  label-width="130px">
            <el-input    maxlength="20"   v-model="addFrom.taxCompetent"></el-input>
          </el-form-item>
           <el-form-item label="注册资本:" prop="registeredCapital" class="jiage">
            <el-input    maxlength="20" v-number-input.float="2"   v-model="addFrom.registeredCapital"></el-input><span  class="danwei">万元</span>
          </el-form-item>
           <el-form-item label="公司地址:" prop="companyAddress" >
            <el-input    maxlength="20"   v-model="addFrom.companyAddress"></el-input>
          </el-form-item>
           <el-form-item label="详细地址:" prop="detailAddress" label-width="130px">
            <el-input   maxlength="20"   v-model="addFrom.detailAddress"></el-input>
          </el-form-item>
           <el-form-item label="所属地区:" prop="provinc">
           <el-cascader ref="cs"   v-model="addFrom.provinc" filterable   :props="props" ></el-cascader>
          </el-form-item>
          <el-form-item label="经营范围:" class="remark" prop="businessScope"  >
            <el-input type="textarea"  :rows="4"  placeholder="" style="width:710px"  maxlength="800" v-model="addFrom.businessScope"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="modifySave">确 定</el-button>
      </span>
    </el-dialog>

</template>

<script>
import { bAreasList } from '@/api/common'
export default {
  name: 'addFlow',
  props: {
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      dialog: false,
      addFrom: {},
      rules: {
        enterpriseType: [
          { required: true, message: '请选择企业类型', trigger: 'blur' }
        ],
        taxCompetent: [
          { required: true, message: '请输入主管税务机关：', trigger: 'blur' }
        ],
        registeredCapital: [
          { required: true, message: '请输入注册资本', trigger: 'blur' }
        ],
        companyAddress: [
          { required: true, message: '请输入公司地址', trigger: 'blur' }
        ],
        detailAddress: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        provinc: [
          { required: true, message: '请选择所属地区', trigger: 'blur' }
        ],
        businessScope: [
          { required: true, message: '请输入经营范围', trigger: 'blur' }
        ]
      },
      props: {
        lazy: true,
        lazyLoad (node, resolve) {
          const { level } = node
          let code = level > 0 ? node.data.value : 100000
          bAreasList({ parentId: code }).then(res => {
            const nodes = res.map(item => ({
              value: item.areaCode,
              label: item.name,
              leaf: level >= 1
            }))
            resolve(nodes)
          })
        }
      }

    }
  },

  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.dialog = true
    this.addFrom.id = this.rowData.id
    this.addFrom.companyName = this.rowData.companyName
  },
  methods: {
    modifySave () {
      this.$refs.addFrom.validate((valid) => {
        if (valid) {
          let seletNode = this.$refs.cs.getCheckedNodes()[0]
          this.addFrom.provinceName = seletNode.parent.label
          this.addFrom.provinceCode = seletNode.parent.value
          this.addFrom.cityName = seletNode.label
          this.addFrom.cityCode = seletNode.value
          this.$emit('save', this.addFrom)
        }
      })
    },
    closeDialog () {
      this.$emit('destroy')
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>

</style>
